import { PropsWithChildren, createContext, useContext } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router';

export enum GROWTH_PATH_TYPE {
	MY_JOB_TITLE = 'MY_JOB_TITLE',
	CAREER = 'CAREER',
	JOB_TITLE = 'JOB_TITLE',
}

export const GrowthPathContext = createContext({
	growthPathType: GROWTH_PATH_TYPE.MY_JOB_TITLE,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setGrowthPathType: (growthPathType: GROWTH_PATH_TYPE) => {},
	userID: '',
	careerID: '',
	jobTitleID: '',
	labelID: '',
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setCareerID: (careerID: string) => {},
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setJobTitleID: (jobTitleID: string) => {},
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setLabelID: (labelID: string) => {},
});

function GrowthPathV2ContextProvider(props: PropsWithChildren) {
	const history = useHistory();

	const { search } = useLocation();

	const { params } = useRouteMatch<{
		userID: string;
		careerID: string;
		jobTitleID: string;
	}>();

	const labelID = new URLSearchParams(search).get('label') ?? '';

	const setLabelID = (labelID: string) => {
		const params = new URLSearchParams(location.search);

		if (labelID && labelID !== 'unlabeled') {
			params.set('label', labelID);
		} else {
			params.delete('label');
		}

		history.push({ search: params.toString() });
	};

	const setJobTitleID = (newJobTitleID: string) => {
		const { pathname, search } = history.location;

		// Replace the existing jobTitleID in the path
		const updatedPath = pathname.replace(/\/job-title\/[^/]+/, `/job-title/${newJobTitleID}`);

		// Preserve existing query params (like ?label=...)
		history.push(`${updatedPath}${search}`);
	};

	return (
		<GrowthPathContext.Provider
			value={{
				growthPathType: GROWTH_PATH_TYPE.MY_JOB_TITLE, // not used in v2
				setGrowthPathType: () => {}, // not used in v2
				userID: params.userID,
				careerID: params.careerID,
				jobTitleID: params.jobTitleID,
				labelID,
				setCareerID: () => {}, // not used in v2
				setJobTitleID,
				setLabelID,
			}}
		>
			{props.children}
		</GrowthPathContext.Provider>
	);
}

export default function GrowthPathContextProvider(props: PropsWithChildren) {
	return <GrowthPathV2ContextProvider {...props} />;
}

export function useGrowthPathContext() {
	return useContext(GrowthPathContext);
}
